var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Canvas",
    transform: "translate(9315 2123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#order_svg__order_svg__path0_fill",
    transform: "translate(-9315 -2122.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#order_svg__order_svg__path1_fill",
    transform: "translate(-9309.68 -2122.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#order_svg__order_svg__path2_fill",
    transform: "translate(-9309.68 -2120.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#order_svg__order_svg__path3_fill",
    transform: "translate(-9309.68 -2117.05)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "order_svg__order_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#order_svg__order_svg__path4_fill",
    transform: "translate(-9309.68 -2114.08)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "order_svg__order_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 4.35111 8.06614L 2.59111 9.82602C 2.57889 9.83825 2.56667 9.85047 2.55444 9.86269C 2.54222 9.87491 2.53 9.88713 2.51778 9.88713C 2.50556 9.89935 2.49333 9.89935 2.48111 9.91157C 2.45667 9.9238 2.43222 9.93602 2.39556 9.94824C 2.38333 9.94824 2.37111 9.96046 2.35889 9.96046C 2.32222 9.97268 2.28556 9.97268 2.24889 9.97268C 2.21222 9.97268 2.17556 9.97268 2.13889 9.96046C 2.12667 9.96046 2.11444 9.96046 2.10222 9.94824C 2.07778 9.93602 2.05333 9.9238 2.01667 9.91157C 2.00444 9.89935 1.99222 9.89935 1.98 9.88713C 1.96778 9.87491 1.95556 9.87491 1.94333 9.86269C 1.93111 9.85047 1.91889 9.83825 1.90667 9.82602L 0.146667 8.06614C -0.0488889 7.8706 -0.0488889 7.56506 0.146667 7.38174C 0.342222 7.1862 0.647778 7.1862 0.831111 7.38174L 1.76 8.31057L 1.76 0.488857C 1.76 0.219986 1.98 0 2.24889 0C 2.51778 0 2.73778 0.219986 2.73778 0.488857L 2.73778 8.31057L 3.66667 7.38174C 3.86222 7.1862 4.16778 7.1862 4.35111 7.38174C 4.54667 7.56506 4.54667 7.8706 4.35111 8.06614Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "order_svg__order_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 5.19444 0.977714L 0.488889 0.977714C 0.22 0.977714 0 0.757728 0 0.488857C 0 0.219986 0.22 0 0.488889 0L 5.19444 0C 5.46333 0 5.68333 0.219986 5.68333 0.488857C 5.68333 0.757728 5.46333 0.977714 5.19444 0.977714Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "order_svg__order_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 4.25333 0.977714L 0.488889 0.977714C 0.22 0.977714 0 0.757728 0 0.488857C 0 0.219986 0.22 0 0.488889 0L 4.25333 0C 4.52222 0 4.74222 0.219986 4.74222 0.488857C 4.74222 0.757728 4.52222 0.977714 4.25333 0.977714Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "order_svg__order_svg__path3_fill",
    fillRule: "evenodd",
    d: "M 3.31222 0.977714L 0.488889 0.977714C 0.22 0.977714 0 0.757728 0 0.488857C 0 0.219986 0.22 0 0.488889 0L 3.31222 0C 3.58111 0 3.80111 0.219986 3.80111 0.488857C 3.80111 0.76995 3.58111 0.977714 3.31222 0.977714Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "order_svg__order_svg__path4_fill",
    fillRule: "evenodd",
    d: "M 2.37111 0.977714L 0.488889 0.977714C 0.22 0.977714 0 0.757728 0 0.488857C 0 0.219986 0.22 0 0.488889 0L 2.37111 0C 2.64 0 2.86 0.219986 2.86 0.488857C 2.86 0.757728 2.64 0.977714 2.37111 0.977714Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.723112952c15af18c9fc7141128fd66f.svg";
export { ForwardRef as ReactComponent };